var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C10 16.5523 9.55228 17 9 17C8.44772 17 8 16.5523 8 16C8 15.4477 8.44772 15 9 15C9.55228 15 10 15.4477 10 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C10 20.5523 9.55228 21 9 21C8.44772 21 8 20.5523 8 20C8 19.4477 8.44772 19 9 19C9.55228 19 10 19.4477 10 20Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17C6.55228 17 7 17.4477 7 18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C16 16.5523 15.5523 17 15 17C14.4477 17 14 16.5523 14 16C14 15.4477 14.4477 15 15 15C15.5523 15 16 15.4477 16 16Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C16 20.5523 15.5523 21 15 21C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19C15.5523 19 16 19.4477 16 20Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18C19 18.5523 18.5523 19 18 19C17.4477 19 17 18.5523 17 18C17 17.4477 17.4477 17 18 17C18.5523 17 19 17.4477 19 18Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8936 16.7617C20.6584 17.0081 20.2624 16.8818 20.0714 16.5998C19.6219 15.9361 18.8619 15.5 18 15.5C17.9924 15.5 17.9848 15.5 17.9772 15.5001C17.6933 15.5026 17.4239 15.3222 17.3169 15.0592C16.9452 14.1447 16.0479 13.5 15 13.5C13.9521 13.5 13.0548 14.1447 12.6831 15.0592C12.5761 15.3222 12.3067 15.5026 12.0228 15.5001C12.0152 15.5 12.0076 15.5 12 15.5C11.9924 15.5 11.9848 15.5 11.9772 15.5001C11.6933 15.5026 11.4239 15.3222 11.3169 15.0592C10.9452 14.1447 10.0479 13.5 9 13.5C7.95208 13.5 7.05476 14.1447 6.68307 15.0592C6.57615 15.3222 6.30673 15.5026 6.02279 15.5001C6.0152 15.5 6.0076 15.5 6 15.5C5.56528 15.5 5.15647 15.611 4.80036 15.8061C4.58511 15.924 4.31139 15.9211 4.1397 15.7457C2.816 14.3933 2 12.5419 2 10.5C2 6.35786 5.35786 3 9.5 3C13.5175 3 16.7973 6.15887 16.991 10.1284C17.3133 10.0446 17.6514 10 18 10C20.2091 10 22 11.7909 22 14C22 15.071 21.5791 16.0437 20.8936 16.7617Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMist);
export default __webpack_public_path__ + "static/media/mist.b540b7c4a22090800bd7aec3942a42e9.svg";
export { ForwardRef as ReactComponent };